// extracted by mini-css-extract-plugin
export default {"formItem":"index-module__g5W3h","assignToUser":"index-module__dmcSP","creatorAnchor":"index-module__hhJxI","dateItem":"index-module__reuD1","userIcon":"index-module__Q3N3t"};